import { create } from 'zustand';

interface LivePresenceState {
  portalUserCount: number | null;
  portalLastUpdatedAt: string | null;
  portalConnected: boolean;
  setPortalPresence: (userCount: number | null) => void;
  setPortalConnected: (connected: boolean) => void;
  resetPortalPresence: () => void;
}

export const useLivePresenceStore = create<LivePresenceState>((set) => ({
  portalUserCount: null,
  portalLastUpdatedAt: null,
  portalConnected: false,
  setPortalPresence: (userCount) =>
    set({
      portalUserCount: userCount,
      portalLastUpdatedAt: userCount === null ? null : new Date().toISOString(),
    }),
  setPortalConnected: (connected) =>
    set({
      portalConnected: connected,
    }),
  resetPortalPresence: () =>
    set({
      portalUserCount: null,
      portalLastUpdatedAt: null,
      portalConnected: false,
    }),
}));

